import { useState } from 'react';
import SEOHead from '@/components/feature/SEOHead';
import Breadcrumb from '@/components/feature/Breadcrumb';

const faqData = [
  {
    question: '黑料网的内容来源是什么？',
    answer: '黑料网的内容来源于用户投稿、网络公开信息以及平台采编团队的原创报道。我们拥有遍布娱乐圈的线人网络和专业的采编团队，确保内容来源的多样性和可靠性。所有爆料内容均经过多方交叉验证后方可发布。',
  },
  {
    question: '如何向黑料网投稿？',
    answer: '您可以通过本页面的投稿表单向我们提交爆料信息。为了保护投稿人的隐私和安全，我们支持匿名投稿。投稿内容经编辑团队审核通过后，会在相应频道发布。我们鼓励原创、真实的爆料内容。',
  },
  {
    question: '黑料网如何确保爆料的真实性？',
    answer: '我们的编辑团队会对每一条爆料进行严格的事实核查，包括多方信源交叉验证、证据材料审核、相关方求证等流程。对于无法确证的信息，我们会明确标注"待核实"。我们坚持"宁缺毋滥"的原则，拒绝传播未经证实的虚假信息。',
  },
  {
    question: '如果发现涉及自己的不实信息该怎么办？',
    answer: '如果您认为黑料网上有涉及您的不实信息，请通过页面底部的联系方式或发送邮件至 tips@heiliaowang.com 与我们联系，提供相关证明材料。我们会在收到申请后24小时内启动核实程序，核实属实后会立即删除或更正相关内容。',
  },
  {
    question: '黑料网的更新频率是怎样的？',
    answer: '黑料网实行全天候实时更新机制，编辑团队7x24小时不间断追踪娱乐圈最新动态。重大爆料事件发生后，我们通常在30分钟内即可完成首发报道，并持续跟踪事件进展，为您提供最及时的爆料资讯。',
  },
];

export default function AboutPage() {
  const [formStatus, setFormStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [formMessage, setFormMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const hpValue = (formData.get('company_alt') as string || '').trim();
    if (hpValue) {
      setFormStatus('success');
      setFormMessage('投稿已提交，感谢您的爆料！');
      return;
    }

    setFormStatus('loading');
    try {
      const urlEncoded = new URLSearchParams();
      formData.forEach((value, key) => {
        if (key !== 'company_alt') {
          urlEncoded.append(key, value as string);
        }
      });

      const response = await fetch('https://readdy.ai/api/form/d9qrp3nnahb7382ovebg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: urlEncoded.toString(),
      });
      const responseText = await response.text();
      if (response.ok) {
        setFormStatus('success');
        setFormMessage('投稿已提交成功！我们的编辑团队将在24小时内审核您的爆料内容。');
        form.reset();
      } else {
        setFormStatus('error');
        setFormMessage('提交失败，请稍后重试或直接发送邮件至 tips@heiliaowang.com');
      }
    } catch {
      setFormStatus('error');
      setFormMessage('网络错误，请检查网络后重试。');
    }
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqData.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <>
      <SEOHead
        title="关于我们 - 黑料网"
        description="黑料网是专注于娱乐圈、网红明星黑料爆料的内容聚合平台。了解我们的品牌故事、团队背景、平台声誉以及联系方式，获取持续更新的真实爆料信息。"
        keywords="黑料网关于我们,黑料网联系方式,黑料网品牌介绍,黑料网团队"
        canonicalUrl="/about"
        schema={[faqSchema]}
      />

      {/* Breadcrumb */}
      <div className="pt-20 bg-background-100 border-b border-background-200/70">
        <div className="max-w-7xl mx-auto">
          <Breadcrumb items={[{ label: '首页', href: '/' }, { label: '关于我们' }]} />
        </div>
      </div>

      {/* Hero */}
      <section className="w-full bg-background-100 px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-3xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-100 text-primary-700 text-sm mb-6">
            <i className="ri-fire-line"></i>
            <span>关于黑料网</span>
          </div>
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950">
            娱乐圈<strong className="text-primary-600">真实爆料</strong>的守护者
          </h1>
          <p className="mt-6 text-lg text-foreground-600 leading-relaxed">
            黑料网成立于2020年，是国内领先的娱乐圈、网红明星黑料爆料内容聚合平台。
            我们致力于为公众提供真实、及时、全面的娱乐圈资讯，成为连接公众与真相的桥梁。
          </p>
        </div>
      </section>

      {/* Stats */}
      <section className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {[
              { number: '5+', label: '年运营经验', icon: 'ri-calendar-check-line' },
              { number: '1,500+', label: '独家爆料文章', icon: 'ri-article-line' },
              { number: '50万+', label: '日活跃用户', icon: 'ri-user-smile-line' },
              { number: '98%', label: '用户满意度', icon: 'ri-heart-line' },
            ].map((stat, index) => (
              <div
                key={index}
                className="text-center p-6 rounded-xl bg-background-50 border border-background-200/70"
              >
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mb-4">
                  <i className={`${stat.icon} text-xl`}></i>
                </div>
                <div className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                  {stat.number}
                </div>
                <div className="text-sm text-foreground-500 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Brand Story */}
      <section className="w-full bg-background-100 px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-12">
            <div className="flex-1">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                  品牌故事
                </h2>
              </div>
              <div className="space-y-4 text-foreground-700 leading-relaxed">
                <p>
                  黑料网诞生于2020年初，由一群热爱娱乐八卦、追求真相的年轻人创建。
                  创始团队有着丰富的媒体从业经验，深知公众对娱乐圈真实信息的需求，也了解传统媒体在报道敏感话题时的种种限制。
                </p>
                <p>
                  我们坚信，<strong className="text-foreground-950">公众有权知道真相</strong>。娱乐产业的繁荣不应建立在信息不对称的基础上，
                  明星艺人的公众形象应当真实可信。黑料网的使命，就是打破信息壁垒，让真实的声音被听见。
                </p>
                <p>
                  经过五年的发展，黑料网已从最初的个人博客发展为一个拥有专业采编团队、
                  遍布全国的线人网络和数百万忠实读者的综合性娱乐资讯平台。
                </p>
              </div>
            </div>
            <div className="flex-1">
              <div className="rounded-xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20modern%20newsroom%20with%20journalists%20working%20at%20desks%2C%20dramatic%20warm%20lighting%2C%20professional%20atmosphere%2C%20editorial%20office%20setting%2C%20Chinese%20media%20company%20interior%2C%20creative%20workspace%20with%20monitors%20and%20news%20boards%2C%20cinematic%20documentary%20style&width=700&height=500&seq=about-brand-story&orientation=landscape"
                  alt="黑料网办公环境"
                  title="黑料网办公环境 - 专业的采编团队"
                  className="w-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="w-full px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <div className="flex items-center justify-center gap-3 mb-4">
              <div className="w-1 h-6 bg-accent-500 rounded-full"></div>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                我们的价值观
              </h2>
            </div>
            <p className="text-foreground-600">黑料网始终坚持以下核心价值理念</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {[
              {
                title: '真实至上',
                desc: '我们坚持每一条爆料都经过严格的事实核查，多方信源交叉验证。宁可慢一点，也要确保信息的真实性。',
                icon: 'ri-shield-check-line',
              },
              {
                title: '独立客观',
                desc: '黑料网保持独立运营，不接受任何艺人或经纪公司的利益输送。我们的报道不受外部力量干预，始终坚持客观公正。',
                icon: 'ri-scales-line',
              },
              {
                title: '保护隐私',
                desc: '我们严格保护爆料人的隐私安全，所有爆料来源信息均经过脱敏处理。投稿人可选择完全匿名方式提供信息。',
                icon: 'ri-lock-line',
              },
            ].map((value, index) => (
              <div
                key={index}
                className="p-6 rounded-xl bg-background-50 border border-background-200/70 text-center"
              >
                <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-5">
                  <i className={`${value.icon} text-2xl`}></i>
                </div>
                <h3 className="text-lg font-heading font-bold text-foreground-950 mb-3">
                  {value.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {value.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="w-full bg-background-100 px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12">
            <div className="flex items-center justify-center gap-3 mb-4">
              <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                常见问题
              </h2>
            </div>
          </div>
          <div className="space-y-4">
            {faqData.map((faq, index) => (
              <details
                key={index}
                className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden"
              >
                <summary className="flex items-center justify-between p-5 cursor-pointer list-none">
                  <h4 className="text-base font-heading font-semibold text-foreground-900 pr-4">
                    {faq.question}
                  </h4>
                  <i className="ri-add-line text-foreground-400 group-open:hidden flex-shrink-0"></i>
                  <i className="ri-subtract-line text-foreground-400 hidden group-open:block flex-shrink-0"></i>
                </summary>
                <div className="px-5 pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </section>

      {/* Contact + Tip Form */}
      <section className="w-full px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-12">
            {/* Contact Info */}
            <div className="flex-1">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                  联系我们
                </h2>
              </div>
              <p className="text-foreground-600 mb-8">
                如果您有任何爆料线索、合作意向或问题反馈，欢迎通过以下方式与我们取得联系。
              </p>
              <div className="space-y-5">
                {[
                  { icon: 'ri-mail-line', label: '电子邮箱', value: 'tips@heiliaowang.com' },
                  { icon: 'ri-phone-line', label: '客服电话', value: '400-888-6666' },
                  { icon: 'ri-map-pin-line', label: '公司地址', value: '北京市朝阳区光华路88号黑料大厦18层' },
                  { icon: 'ri-time-line', label: '工作时间', value: '周一至周日 9:00 - 24:00（全年无休）' },
                ].map((item, index) => (
                  <div key={index} className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                      <i className={`${item.icon} text-lg`}></i>
                    </div>
                    <div>
                      <div className="text-sm text-foreground-500">{item.label}</div>
                      <div className="text-base text-foreground-900 font-medium mt-0.5">{item.value}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Tip Form */}
            <div className="flex-1">
              <div className="bg-background-50 border border-background-200/70 rounded-xl p-6 md:p-8">
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-500 text-white">
                    <i className="ri-megaphone-line"></i>
                  </div>
                  <h3 className="text-xl font-heading font-bold text-foreground-950">
                    爆料投稿
                  </h3>
                </div>
                {formStatus === 'success' ? (
                  <div className="text-center py-12">
                    <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-4">
                      <i className="ri-check-line text-2xl"></i>
                    </div>
                    <p className="text-foreground-900 font-medium">{formMessage}</p>
                  </div>
                ) : (
                  <form id="about-tip-form" data-readdy-form onSubmit={handleSubmit} className="space-y-4">
                    <div className="hp-field-wrap">
                      <input type="text" name="company_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
                    </div>
                    <div>
                      <label htmlFor="tip-title" className="block text-sm font-medium text-foreground-700 mb-1.5">
                        爆料标题 <span className="text-primary-500">*</span>
                      </label>
                      <input
                        id="tip-title"
                        type="text"
                        name="tip_title"
                        required
                        maxLength={100}
                        placeholder="简要描述爆料内容"
                        className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-300 text-foreground-900 placeholder:text-foreground-400"
                      />
                    </div>
                    <div>
                      <label htmlFor="tip-category" className="block text-sm font-medium text-foreground-700 mb-1.5">
                        所属分类 <span className="text-primary-500">*</span>
                      </label>
                      <select
                        id="tip-category"
                        name="tip_category"
                        required
                        className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-300 text-foreground-900"
                      >
                        <option value="">请选择分类</option>
                        <option value="明星八卦">明星八卦</option>
                        <option value="网红爆料">网红爆料</option>
                        <option value="综艺内幕">综艺内幕</option>
                        <option value="音乐圈">音乐圈</option>
                        <option value="其他">其他</option>
                      </select>
                    </div>
                    <div>
                      <label htmlFor="tip-content" className="block text-sm font-medium text-foreground-700 mb-1.5">
                        详细内容 <span className="text-primary-500">*</span>
                      </label>
                      <textarea
                        id="tip-content"
                        name="tip_content"
                        required
                        rows={5}
                        maxLength={500}
                        placeholder="请详细描述您要爆料的内容，包括时间、地点、人物、事件经过等"
                        className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-300 text-foreground-900 placeholder:text-foreground-400 resize-none"
                      ></textarea>
                      <p className="text-xs text-foreground-400 mt-1">最多500字符</p>
                    </div>
                    <div>
                      <label htmlFor="tip-email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                        联系邮箱 <span className="text-foreground-400">(选填)</span>
                      </label>
                      <input
                        id="tip-email"
                        type="email"
                        name="tip_email"
                        placeholder="如需回复请留下邮箱"
                        className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-300 text-foreground-900 placeholder:text-foreground-400"
                      />
                    </div>
                    <button
                      type="submit"
                      disabled={formStatus === 'loading'}
                      className="w-full py-3 bg-primary-500 text-white rounded-lg font-medium text-sm hover:bg-primary-600 transition-all duration-300 disabled:opacity-60 whitespace-nowrap"
                    >
                      {formStatus === 'loading' ? '提交中...' : '提交爆料'}
                    </button>
                  </form>
                )}
                {formStatus === 'error' && (
                  <p className="mt-3 text-sm text-red-500 text-center">{formMessage}</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}